<template>
	<div class="datepicker-days" >
		<table v-for="(month,$index) in tableData" >
			<thead>
				<tr>
					<th >
						<i v-show="$index==0" @click="min"><</i>
					</th>
					<th colspan="5">{{getNormalMonth(monthIndex+Number($index))}} </th>
					<th >
						<i v-show="$index==1" @click="add">></i>
					</th>
				</tr>
			</thead>
            <thead>
                <tr>
                    <th>日</th>
                    <th>一</th>
                    <th>二</th>
                    <th>三</th>
                    <th>四</th>
                    <th>五</th>
                    <th>六</th>
                </tr>
            </thead>
            <tbody>
            	<tr v-for="week in month">
            		<td :class="(getDaysSize(today,(getNormalMonth(monthIndex+Number($index))+'-'+day)))>=0?(checkSelectedDays(getNormalMonth(monthIndex+Number($index)),day)&&day?'day active':'day'):(day?'disable':'')" v-for="day in week" @click="select(getNormalMonth(monthIndex+Number($index)),day)">
            			{{day}}
            			
            		</td>
            	</tr>
            </tbody>
		</table>
		
	</div>
</template>

<script>
export default {	
	name:'datePicker',
	props:{
    value:{
    	type: String,
      default: ''
    },
       
        
  },
	data(){
		return{
			monthIndex:0,
			today:this.getDate(0),
			tableData:{},
			selectedDays:this.getDate(0),
			day:''
		}
	},
	watch:{
		monthIndex(){
			this.initTable();
		},
		day(val){
			this.selectedDays = val
		},
	},
	methods:{
		add(){
			if(this.monthIndex < 11) {
				this.monthIndex += 1;
			}
			
		},
		min(){
			if(this.monthIndex > 0) {
				this.monthIndex -= 1;
			}
		},
		select(month,day){
			if(day<10){
				day='0'+day;
			}
			this.selectedDays=month+'-'+day;
			this.$emit('onDateChange',this.selectedDays)
		},
		//检查是不是已经选中了，选中的取消，否则选中
		checkSelectedDays(month,day){
			if(day<10){
				day='0'+day;
			}
			var selectedDays=this.selectedDays;
			if(!selectedDays)return;
			if(selectedDays==(month+'-'+day)){
					return selectedDays;
			}
			return false;
		},
		/*获取一个月的天数 */
		getCountDays(date) {
			
			date=date.replace(/-/g,"/");
			date=date+'/01';

		    var curDate = new Date(date);
		    /* 获取当前月份 */
		    var curMonth = curDate.getMonth();
		    /*  生成实际的月份: 由于curMonth会比实际月份小1, 故需加1 */
		    curDate.setMonth(curMonth + 1);
		    /* 将日期设置为0, 这里为什么要这样设置, 我不知道原因, 这是从网上学来的 */
		    curDate.setDate(0);
		    /* 返回当月的天数 */
		       
			return curDate.getDate();
		},
		//获取一个月份的每一天
		getEvryDay(index){

			var dayArry=[];
			var date=this.getNormalMonth(index);

			var day=this.getCountDays(date);

			for (var k = 1; k <= day; k++) {
				dayArry.push(k);
			}
			return dayArry;
		},
		//生成表格数据结构
		initTable(){
			var array={};
			
			
			for(var i=0;i<2;i++){
				var index=this.monthIndex;
				var days=this.getEvryDay(i+index);
				var daysArray=days;	
				var temp=this.getFullfillDateTable(daysArray,this.getNormalMonth(index+i)+'-01');
				array[i]=temp;
			}
			this.tableData=array;
		},
   		//将数据格式化表格日期格式
        getFullfillDateTable(data,date){
            var data=data;
            var weekday=this.getWeekday(date);
            for(var i=0;i<weekday;i++){
                 data.unshift('');
            }
            var result = [];
            //补全日期前几天
            for(var i=0,len=data.length;i<len;i+=7){
               result.push(data.slice(i,i+7));
            }
            //补全日期后几天
            var length=result[(result.length-1)].length;
            if(length<7){
                for(var i=0;i<(7-length);i++){
                    result[(result.length-1)].push('');
                }
            }
            return result;
          
        },
	},
	mounted(){
		var that=this;
		that.day = that.value
		that.initTable();
		var body= document.getElementsByTagName("body");
    if(!body[0]){return}//判断页面是否html不完整，没有body元素
		//给body添加事件委托，监听input的点击事件
    body[0].addEventListener('click',function(e){
      if(e.target.className&&e.target.className!='datepicker-days'){
        that.$emit('onDateChange');
      }
    })

	}
}
</script>



// WEBPACK FOOTER //
// src/common/DatePicker/DatePicker.vue